var Class   = require("Class"),
    $       = require("jquery");


var Collection = Class.extend({

    /**
     * Базовый класс коллекции объектов (моделей) предоставляющий основные методы
     * для управления набором данных(добавление, удаление, фильтрация, ...)
     *
     * @class Collection
     * @namespace omjs
     * @extends Class
     * @constructor
     * @param {Object[]|Model[]} [objects] - массив объектов или моделей
     * @param {Object} [options] - объект с опциями коллекции в формате ключ - значение

     * @example
     *     var collection = new omjs.Collection([model1, model2, model3, ...], {
     *         option1: option1_value,
     *         ...
     *     });
     */
    initialize: function(objects, options){
        var that = this,
            objs;

        objs = objects || [];

        that.reset(objs);

        options = options || {};
        that.setOptions(options);
    },

    /**
     * Возвращает длину коллекции
     *
     * @method getLength
     * @returns {Number}
     */
    getLength: function() {
        return this.getArray().length;
    },

    /**
     * Возвращает элементы коллекции в виде массива
     *
     * @method getArray
     * @returns {Object[]|omjs.Model[]}
     */
    getArray: function(){
        return this._items;
    },

    /**
     * Возвращает ондекс элемента в коллекции, указанного в параметре object.
     * Если елемент отсутствует в коллекции метод вернет -1
     *
     * @method indexOf
     * @param {Object|omjs.Model} object - объект, индекс которого будет определен
     * @returns {Number}
     */
    indexOf: function(object){
        return this._items.indexOf(object);
    },

    /**
     * Определяет есть ли такой елемент (массив елементов) в коллекции
     *
     * @method has
     * @param {Object|Object[]} objects - объект или массив объектов
     * @returns {Boolean}
     */
    has: function(objects) {
        var that = this,
            result = true,
            i;

        if (!$.isArray(objects)) {
            result = that._items.indexOf(objects) !== -1;
        } else {
            for(i in objects) {
                result &= that._items.indexOf(objects[i]) !== -1;
            }
        }
        return result;
    },

    /**
     * Возвращает елемент коллекции с указанным индексом
     *
     * @method at
     * @param {number} index - индекс элемента
     * @returns {Object|omjs.Model}
     */
    at: function(index){
        return this._items[index];
    },

    /**
     * Добавляет элемент или массив элементов в коллекцию
     *
     * @method add
     * @chainable
     * @param {Object[]|omjs.Model[]} objects - элемент или массив элементов
     * @returns {this}
     *
     */
    add: function(objects){
        var that = this,
            _objects,
            i;

        _objects = $.isArray(objects) ? objects : [objects];

        for (i in _objects) {
            if (_objects[i]) {
                that._items.push(_objects[i]);
            }
        }
        return that;
    },

    /**
     * Удаляет элементы из коллекции
     *
     * @method remove
     * @param {Object[]|omjs.Model[]} objects - элемент или массив элементов для удаления
     */
    remove: function(objects){
        var that = this,
            _objects,
            removed,
            result = [],
            i;

        _objects = $.isArray(objects) ? objects : [objects];

        for (i in _objects) {
            if (that.has(_objects[i])) {
                removed = that._items.splice(that.indexOf(_objects[i]), 1);
                result.push(removed);
            }
        }

        return that;
    },

    /**
     * Метод создает массив из атрибутов моделей коллекции
     *
     * @param {String} attrName - Имя атрибута, значения которого будут использованы для создания массива
     * @returns {Array}
     *
     * @example
     *      var collection = new omjs.Collection([
     *          {a:1, b:2},
     *          {a:3, b:2},
     *          {a:5, b:2}
     *      ]);
     *
     *      collection.pluck("a");
     *      // результат [1,3,5];
     */
    pluck: function(attrName){
        var that = this,
            result = [],
            i;

        if (that.getLength()) {
            for(i in that._items) {
                result.push(that._items[i].get(attrName));
            }
        }

        return result;
    },

    /**
     * Метод позволяет отфильтровать этементы коллекции и получить их в виде новой коллекции
     *
     * @method filter
     * @param {Function} predicate - функция для фильтрации
     * @return {omjs.Collection}
     *
     * @example
     *      var collection = new omjs.Collection([
     *          {a:1, b:2},
     *          {a:3, b:1},
     *          {a:5, b:2}
     *          {a:3, b:1},
     *          {a:5, b:2}
     *      ]);
     *
     *      var result = collection.filter(function(obj, i){
     *          return obj.get("b") == 2;
     *      };
     *      // результат новая коллекция с элементами 0, 2, 4;
     */
    filter: function(predicate){
        var that = this,
            result = [],
            callback;

        callback = $.isFunction(predicate)
            ? predicate
            : function() {return true;};

        that._items.forEach(function(obj, i){
            if (callback(obj, i)) {
                result.push(obj);
            }
        });

        return new that.constructor(result);
    },

    each: function(iteratee) {
        var that = this;
        that._items.forEach(iteratee);
        return that;
    },

    /**
     * Очищает коллекцию и записывает в нее элементы objects
     *
     * @method reset
     * @chainable
     * @param {Object[]|omjs.Model[]} objects - массив объектов или моделей
     */
    reset: function(objects){
        var that = this;

        that._items = [];
        if(objects){
            that.add(objects);
        }

        return that;
    }
});

module.exports = Collection;



//////////////////
// WEBPACK FOOTER
// ./src/~/Collection.js
// module id = 8
// module chunks = 0